const PlanData = [
  {
    plan: 'subscriber',
    numberOfFile: 15,
    collectMaxSubmission: 10,
    selfJoinMaxSubmission: 10,
    icpComments: 400,
    numberOfImage: 40,
    hasUnlimited: false,
    shareWheelNoAds: false,
    aiInputQuota: 3,
  },
  {
    plan: 'personalized',
    numberOfFile: 40,
    collectMaxSubmission: 40,
    selfJoinMaxSubmission: 40,
    icpComments: 2000,
    numberOfImage: 40,
    hasUnlimited: false,
    shareWheelNoAds: false,
    aiInputQuota: 40,
  },
  {
    plan: 'professional',
    numberOfFile: 70,
    collectMaxSubmission: 200,
    selfJoinMaxSubmission: 200,
    icpComments: 4000,
    numberOfImage: 100,
    hasUnlimited: false,
    shareWheelNoAds: true,
    aiInputQuota: 100,
  },
  {
    plan: 'business',
    numberOfFile: 120,
    collectMaxSubmission: 30000,
    selfJoinMaxSubmission: 2000,
    icpComments: Infinity, // Unlimited
    numberOfImage: 300,
    hasUnlimited: true,
    shareWheelNoAds: true,
    aiInputQuota: Infinity,
  },
]

export default PlanData
